import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

function ProtectedRoute({ children }) {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const hasLabsPermission = useSelector((state) => state.auth.hasLabsPermission);
  const hasActivePlan = useSelector((state) => state.auth.hasActivePlan);
  const location = useLocation();
  const currentPath = location.pathname;


  if (!isAuthenticated && !hasLabsPermission) {
    return <Navigate to="*" replace />;
  }

  if (isAuthenticated && !hasActivePlan && 
      currentPath !== '/plan' && 
      currentPath !== '/perfil' && 
      currentPath !== '/login') {
    return <Navigate to="/plan" replace />;
  }

  return children;
}

export default ProtectedRoute;